import { createSelectorCreator, defaultMemoize } from 'reselect';
import { is } from 'immutable';

const createImmutableSelector = createSelectorCreator(defaultMemoize, is);

const homeSelector = state => state.environments.fhe.data.Homes.get('list');
const boxSelector = state => state.environments.fhe.data.Boxes.get('list');
const profileSelector = state => state.data.user;
const homeInitialized = state => state.environments.fhe.data.Homes.get('initialized');
const userInitialized = state => state.environments.fhe.data.Users.get('initialized');

const mergeBoxInHome = (Homes, Boxes) => {
    Boxes.map(Box => {
        if (Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1 && Homes.has(Box.get('homeId').toString())) {
            Homes = Homes.mergeIn([Box.get('homeId').toString()], Box);
        }
    });
    return Homes;
};
export default {
    getHomes: homeSelector,
    getHomesWithBoxes: createImmutableSelector([homeSelector, boxSelector], mergeBoxInHome),
    getProfile: profileSelector,
    getHomesInitialized: homeInitialized,
    getUsersInitialized: userInitialized
};



// WEBPACK FOOTER //
// ./environments/fhe/data/selectors.js